import styled from "styled-components";
import { colorBlack, colorPrimary, colorPrimaryButton, colorPrimaryDark2Hex, colorPrimaryText, colorWhite } from "../../styles/abstract/variables";
import { Link } from "react-router-dom";

export const ButtonStyled = styled(Link) `
    &,
    &:link,
    &:visited {
        text-transform: uppercase;
        text-decoration: none;
        padding: 1rem 3rem;
        display: inline-block;
        border-radius: 10rem;
        transition: all .2s;
        position: relative;
        color: ${colorBlack};
        background-color: ${colorWhite};
        font-size: 1.5rem;
        display: inline-block;

        //change for the <button> element
        border: none;
        cursor: pointer;
    }

    .btn__arrow {
        padding-left: .8rem;
        transition: all .2s;
    }

    &--animated {
        animation: moveInBottom .5s ease-out .75s;
        animation-fill-mode: backwards;
    }

    &:hover{
        transform: translateY(-.3rem);
        box-shadow: 0 1rem 2rem rgba(0,0,0, .3);

    }

    &:hover .btn__arrow {
        padding-left: 1rem;
    }

    &:active,
    &:focus  {
        outline: none;
        transform: translateY(-.1rem);
        box-shadow: 0 .5rem 1rem rgba(0,0,0, .2);
    }
`;

export const EventButtonStyled = styled(Link) `
    &,
    &:link,
    &:visited {
        text-transform: uppercase;
        text-decoration: none;
        padding: 1rem 3rem;
        display: inline-block;
        border-radius: 1rem;
        transition: all .2s;
        position: relative;
        color: ${colorPrimaryText};
        background-color: ${colorPrimaryButton};
        font-size: 1.5rem;
        display: inline-block;
        width: 100%;
        text-align: center; 
        border: 1px solid ${colorPrimaryText};

        //change for the <button> element
        cursor: pointer;
    }
    
    &.btn__white {
        background-color: ${colorWhite} !important;
    }


    &.btn__blue {
        background-color: ${colorPrimary} !important;
        color: ${colorWhite}
    }

    .btn__arrow {
        display: none;
    }

    &.btn--animated {
        animation: moveInBottom .5s ease-out .75s;
        animation-fill-mode: backwards;
    }

    &:hover{
        transform: translateY(-.1rem);
        box-shadow: 0 .5rem 1rem rgba(0,0,0, .3);
    }

    &:active,
    &:focus  {
        outline: none;
        transform: translateY(-.1rem);
        box-shadow: 0 .5rem 1rem rgba(0,0,0, .2);
    }
`;

export const Inverted = styled(Link) `
    &,
    &:link,
    &:visited {
        text-transform: uppercase;
        text-decoration: none;
        padding: 1rem 3rem;
        display: inline-block;
        border-radius: 10rem;
        transition: all .2s;
        position: relative;
        color: ${colorWhite};
        background-color: ${colorPrimaryDark2Hex};
        font-size: 1.5rem;
        display: inline-block;

        //change for the <button> element
        border: none;
        cursor: pointer;
    }

    .btn__arrow {
        padding-left: .8rem;
        transition: all .2s;
    }

    &--animated {
        animation: moveInBottom .5s ease-out .75s;
        animation-fill-mode: backwards;
    }

    &:hover{
        transform: translateY(-.3rem);
        box-shadow: 0 1rem 2rem rgba(0,0,0, .3);

    }

    &:hover .btn__arrow {
        padding-left: 1rem;
    }

    &:active,
    &:focus  {
        outline: none;
        transform: translateY(-.1rem);
        box-shadow: 0 .5rem 1rem rgba(0,0,0, .2);
    }
`;

export const Admin = styled.button `
    &,
    &:link,
    &:visited {
        text-transform: uppercase;
        text-decoration: none;
        padding: 1rem 3rem;
        display: inline-block;
        border-radius: 10rem;
        transition: all .2s;
        position: relative;
        color: ${colorWhite};
        background-color: ${colorPrimary};
        font-size: 1.5rem;
        display: inline-block;

        //change for the <button> element
        border: none;
        cursor: pointer;
    }

    .btn__arrow {
        display: none;
    }

    &--animated {
        animation: moveInBottom .5s ease-out .75s;
        animation-fill-mode: backwards;
    }

    &:hover{
        transform: translateY(-.3rem);
        box-shadow: 0 1rem 2rem rgba(0,0,0, .3);

    }

    &:hover .btn__arrow {
        padding-left: 1rem;
    }

    &:active,
    &:focus  {
        outline: none;
        transform: translateY(-.1rem);
        box-shadow: 0 .5rem 1rem rgba(0,0,0, .2);
    }
`;